import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-flashlight-sharp",
  "use": "icon-flashlight-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-flashlight-sharp\"><title>Flashlight</title><path d=\"M330 16l-42.68 42.7L453.3 224.68 496 182 330 16z\" /><ellipse cx=\"224.68\" cy=\"287.3\" rx=\"20.03\" ry=\"19.96\" fill=\"none\" /><path d=\"M429.21 243.85L268 82.59 249.65 168 16 402l94 94 234.23-233.8zm-189 56.07a20 20 0 110-25.25 20 20 0 01-.02 25.25z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol